import { ExcelColumn } from "api/generated/lumen";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface UseContractorsListColumnTitles {
  columns: ExcelColumn[];
}

const useContractorsListColumnTitles = (): UseContractorsListColumnTitles => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        displayName: t("contractor.name"),
        propertyName: "name",
      },
      {
        displayName: t("contractor.address.zip"),
        propertyName: "headquarterZip",
      },
      {
        displayName: t("contractor.address.city"),
        propertyName: "headquarterCity",
      },
      {
        displayName: t("contractor.address.street"),
        propertyName: "headquarterAddress",
      },
      {
        displayName: t("contractor.address.houseNumber"),
        propertyName: "headquarterNumber",
      },
      {
        displayName: t("contractor.status"),
        propertyName: "status",
      },
    ],
    [t]
  );

  return {
    columns,
  };
};

export default useContractorsListColumnTitles;
